/** Общие слова и форматы: единица кредитов, этапы, действия, навигация, относительное время. */
export const common = {
  creditsUnit: 'кр.',
  'stage.prep': 'Подготовка',
  'stage.round1': 'Круг 1 · график и направление',
  'stage.round2': 'Круг 2 · шкала цен',
  'stage.round3': 'Круг 3 · состав и пункты',
  'stage.locked': 'Ожидание закрытия свечи',
  'stage.settled': 'Расчёт',
  'stage.cancelled': 'Отменён',
  'action.ante': 'взнос',
  'action.fold': 'пас',
  'action.check': 'чек',
  'action.call': 'колл',
  'action.bet': 'ставка',
  'action.raise': 'райз',
  'action.raiseTo': 'райз до',
  'action.allin': 'олл-ин',
  auto: 'авто',
  loading: 'Загрузка…',
  cancel: 'Отмена',
  confirm: 'Подтвердить',
  close: 'Закрыть',
  back: '← Назад',
  forward: 'Вперёд →',
  pages: 'Страницы',
  pageOf: '{page} из {pages} · всего {total}',
  never: 'никогда',
  justNow: 'только что',
  minutesAgo: '{n} мин назад',
  hoursAgo: '{n} ч назад',
  daysAgo: '{n} дн назад',
  noData: 'Данных пока нет.',
  bot: 'бот',
  botPrefix: 'Бот',
  language: 'Язык',
};
